<template>
    <w-flex wrap class="justify-space-between">
        <div class="xs8 headline text-left pl7 monitoring-title">
            <span>
                <!-- otherwise the anchor element would wrap the icon incrrectly -->
                <router-link :to="bsname" class="back-link">
                    <w-icon class="v-middle" fill-height color="primary">
                        mdi mdi-arrow-left
                    </w-icon>
                </router-link>
            </span>
            <span> Monitoring Base Station</span>
        </div>
    </w-flex>
    <w-flex class="mx3">
        <!-- TODO manage input local time with UTC  -->
        <w-input v-model="rangeinput.start" type=datetime-local :max="rangeinput.end"
            @update:model-value="updateStartRange()">Start</w-input>
        <div class="spacer"></div>
        <w-input v-model="rangeinput.end" type=datetime-local :max="new Date().toLocaleString()"
            @update:model-value="updateEndRange()">End</w-input>
        <div class="spacer"></div>
        <w-select :items="ranges" v-model="range" @update:model-value="updateFilters()">Time Depth</w-select>
        <w-select :items=intervals v-model="interval" @update:model-value="updateInterval()">Interval</w-select>
        <div class="spacer"></div>
        <!-- <w-checkbox v-model="line">Scatter Chart</w-checkbox> -->

    </w-flex>
    <div v-if="barChartstore.state.loading">
        <w-progress class="ma1" :model-value="undefined" bar />
    </div>
    <w-flex class="mx3">
        <BarChart :chartData="barChartstore.state.config.data" class="fill-width" />
    </w-flex>
    <div v-if="lineChartstore.state.loading">
        <w-progress class="ma1" :model-value="undefined" bar />
    </div>
    <w-flex class="mx3">
        <LineChart :chartOptions="lineChartstore.state.config.options" :chartData="lineChartstore.state.config.data"
            class="fill-width" />
    </w-flex>
    <!-- <w-flex>
        <LineChartGenerator
    chart-id="chartID"
    :chart-options="lineChartstore.state.config.options"
    :chart-data="lineChartstore.state.config.data"
  />
    </w-flex> -->
</template>

<script>
import {
    Chart, registerables
} from 'chart.js'
import { BarChart, LineChart } from 'vue-chart-3'
import { barChartstore, lineChartstore } from '../store/monitoring-graph'
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ref } from 'vue'
import { reactive } from 'vue'
import { secondsToFormattedString, formattedStringToSeconds } from "@/utils/time-formatter"

// import { Line as LineChartGenerator } from "vue-chart";

Chart.register(...registerables)


const chart_bytes = window.__env?.defaults?.chart_bytes||{
            "interval_seconds":400,
            "range_seconds": 3600
        };
const env_range = chart_bytes.range_seconds;
const env_interval = chart_bytes.interval_seconds;

export default {
    name: 'MonitioringStationGraphView',
    components: {
        BarChart,
        LineChart,
        // LineChartGenerator
    },
    setup() {
        const loading = ref(true);
        const bsname = ref('/monitoring/')
        const delayed = reactive({
            timer: 0,
            function: null,
            ms: 500,
        });
        const rangeinput = reactive({ start: 0, end: 0 })


        const range = ref(env_range ? env_range : 2 * 60 * 60)
        const interval = ref(env_interval ? env_interval : 500)

        const configData = computed(() => barChartstore.state.config)

        let buildLabel = (val) => {
            if (val < 60) { return val + " sec" } else {
                return val < (60 * 60) ? Math.floor(val / 60) + " min " + (val % 60 > 0 ? val % 60 + " sec" : "") : Math.floor(val / (60 * 60)) + " h " + (val % (60 * 60) > 0 ? (Math.floor((val % (60 * 60)) / 60) + " min " + ((val % (60 * 60)) % 60 > 0 ? (val % (60 * 60)) % 60 + " sec " : "")) : "")
            }
        }

        let getRanges = () => {
            let result = [{ label: "1 min", value: 60 }, { label: "30 min", value: 30 * 60 }, { label: "1 h", value: 60 * 60 }, { label: "2 h", value: 2 * 60 * 60 }, { label: "5 h", value: 5 * 60 * 60 }, { label: "10 h", value: 10 * 60 * 60 }, { label: "12 h", value: 12 * 60 * 60 }, { label: "24 h", value: 24 * 60 * 60 }]
            if (env_range && !result.some((r) => r.value == env_range)) {
                result.push({ label: buildLabel(env_range), value: env_range })

            } return result;

        }
        let getIntervals = () => {
            let result = [{ label: "30 min", value: 1800 }, { label: "5 min", value: 300 }, { label: "1 min", value: 60 }, { label: "30 sec", value: 30 }, { label: "10 sec", value: 10 }, { label: "1 sec", value: 1 }];

            if (env_interval && !result.some((r) => r.value == env_interval)) {
                result.push({ label: buildLabel(env_interval), value: env_interval })

            } return result;
        }
        const ranges = ref(getRanges())
        const intervals = ref(getIntervals())
        function getPathBaseStation() {
            // router system must be changed to retrive path variables
            const route = useRoute();
            console.log(route.params.basestation);
            return route.params.basestation;
        }
        function updateFilters() {
            loading.value = true
            let nowtime = Math.floor(new Date().getTime() / 1000)
            rangeinput.start = secondsToFormattedString(nowtime - range.value);
            rangeinput.end = secondsToFormattedString(nowtime);
            barChartstore.updateRange(nowtime, nowtime - range.value)
            lineChartstore.updateRange(nowtime, nowtime - range.value)
            loading.value = false
        }
        function updateEndRange() {
            loading.value = true
            clearTimeout(delayed.timer);
            delayedSearch(() => {
                // if time zone i just need to formatt my labes as time zone and get the init time as new date  
                // if not time zone any new date need - when interactin wuth input   
                let end = formattedStringToSeconds(rangeinput.end)
                // let start = formattedStringToSeconds(rangeinput.start)

                barChartstore.state.filters.rangeEnd = end;
                lineChartstore.state.filters.rangeEnd = end;
            })
            loading.value = false
        }
        function updateStartRange() {
            loading.value = true
            clearTimeout(delayed.timer);
            delayedSearch(() => {
                // if time zone i just need to formatt my labes as time zone and get the init time as new date  
                // if not time zone any new date need - when interactin wuth input   
                //let end = formattedStringToSeconds(rangeinput.end)
                let start = formattedStringToSeconds(rangeinput.start)

                barChartstore.state.filters.rangeStart = start;
                lineChartstore.state.filters.rangeStart = start;
            })
            loading.value = false
        }
        function delayedSearch(funct) {
            clearTimeout(delayed.timer);
            delayed.timer = 0;
            delayed.function = funct
            delayed.ms = 1000;
            clearTimeout(delayed.timer);
            delay();
        }

        function delay(...args) {
            delayed.timer = setTimeout(delayed.function.bind(...args), delayed.ms);
        }
        function updateInterval() {
            lineChartstore.state.interval = interval.value;
            barChartstore.state.interval = interval.value;
        }

        onMounted(async () => {
            // loading.value = true


            const initTime = Math.floor(new Date().getTime() / 1000)
            console.log("load ", initTime);
            bsname.value = '/monitoring/' + getPathBaseStation()
            let [result1, result2] = await Promise.all([barChartstore.initBar(getPathBaseStation(), initTime), lineChartstore.initLine(getPathBaseStation(), initTime)]).catch(e => console.log(e))
            console.log(result1, result2);

            loading.value = false
            rangeinput.start = secondsToFormattedString(initTime - range.value);
            rangeinput.end = secondsToFormattedString(initTime);
        })


        return { interval, loading, bsname, ranges, range, intervals, configData, barChartstore, lineChartstore, updateFilters, rangeinput, updateEndRange, updateStartRange, secondsToFormattedString, updateInterval }
    }
}
</script>

<style scoped>
.monitoring-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.back-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.v-middle {
  vertical-align: middle;
}
</style>

